import { get, debounce, invoke } from 'lodash';
import takeRight from 'lodash/takeRight';
import PinchZoom from 'pinch-zoom-js';
import views from './components/views';
import GDPR from './components/gdpr';
import Survey from './components/survey';
import { DISQUALIFICATION_USER_UNDERAGE } from './constants';

// handles all the click, scroll, tap events
Pollfish.event = (function event() {
  return {
    // return true if a user just clicked
    // "none of the above" option in multiple choice question
    clickedNoneOfTheAbove(el) {
      return Boolean($(el).hasClass('none-of-the-above'));
    },

    // return true if "none of the above" option
    // is already selected in a multiple choice question
    noneOfTheAboveSelected() {
      return Boolean($('.none-of-the-above').hasClass('answerClick'));
    },
    // return true if user just clicked
    // "other" option
    clickedOtherAnswer(el) {
      return Boolean($(el).hasClass('answer-other'));
    },
    takeSurvey() {
      // on tap/click load the main template which handles all the questions and answers
      $('html').on('tap', '.js-take-survey-btn', (e) => {
        e.preventDefault();
        if (Pollfish.helper.hasAcceptedTerms()) {
          Pollfish.survey = new Survey(Pollfish.helper.json);
          Pollfish.survey.start().catch(Pollfish.helper.handleError);
          return;
        }

        new GDPR({ currentPage: views.common.gdpr }).render();
      });
    },

    getStarted() {
      $('html').on('tap', '.js-get-started-btn', function onTap(e) {
        e.preventDefault();
        // these are needed because this event might be attached multiple times due to bad coding
        e.stopImmediatePropagation();
        const isUnlockScreen = $(this).data('page') === 'unlock-screen';
        if (Pollfish.helper.hasAcceptedTerms()) {
          Pollfish.survey = new Survey({
            ...Pollfish.helper.json.tag_survey,
            isOfferwallDemographics: isUnlockScreen,
          });
          Pollfish.survey.start().catch(Pollfish.helper.handleError);
          return;
        }

        new GDPR({
          currentPage: views.common.gdpr,
          isOfferwallDemographics: isUnlockScreen,
        }).render();
      });
    },

    noThanks() {
      // on tap/click close the panel and don't show indicator
      $('#wrapper').off('tap', '.js-survey-reject-btn');
      $('#wrapper').on('tap', '.js-survey-reject-btn', (e) => {
        e.preventDefault();
        Pollfish.analytics.sendEvent('general', 'noThanks', 'No Thanks', 1100);
        Pollfish.mobile.interface.userRejectedSurvey();
        if (
          Pollfish.helper.isOfferwall() &&
          Pollfish.helper.json.hasCustomTerms
        ) {
          Pollfish.ui.showOfferwall();
        } else {
          Pollfish.mobile.interface.closeAndNoShow();
        }

        const data = {
          s_id: `${Pollfish.helper.json.s_id}`,
        };
        const noCheck = invoke(Pollfish, 'survey.getNoCheck');
        if (noCheck !== null) {
          data.no_check = noCheck;
        }

        Pollfish.mobile.interface.sendToServer(
          '/v2/device/set/survey/reject',
          JSON.stringify(data),
          false,
        );
      });
    },

    withdrawConsent() {
      $('#wrapper').on('tap', '.js-withdraw-consent', (e) => {
        e.preventDefault();
        const sig = Pollfish.helper.json.withdraw_sig;
        const deviceId = Pollfish.helper.json.raw.device_id;
        Pollfish.mobile.interface.openWebsite(
          `https://www.pollfish.com/lp/withdraw-consent?sig=${sig}&deviceId=${deviceId}`,
        );
      });
    },

    close() {
      // on tap/click close the panel and show indicator
      $('#wrapper').on('tap', '.header__action-close-btn', (e) => {
        e.preventDefault();
        const currentPage = $('body').attr('data-page') || '';
        const shouldShowModal = currentPage.match(
          /(question-|tag-|wait-screen|survey-start-screen)/,
        );
        const storedOffer = Pollfish.store.getSelectedOffer();
        if (currentPage === 'gdpr' && Pollfish.helper.isOfferwall()) {
          Pollfish.store.setSelectedOffer(null);
          Pollfish.store.setIsPreviousPageGDPR(true);
        } else if (currentPage === 'gdpr') {
          Pollfish.helper.initSingleSurvey();
          Pollfish.store.setIsPreviousPageGDPR(true);
        }
        if (shouldShowModal && Pollfish.survey.isFeedbackSurvey()) {
          // the user decided to not provide us with feedback for the rejection reason
          Pollfish.helper.handleSurveyReject();
          return;
        }
        if (shouldShowModal) {
          const title = Pollfish.ui.getText('offerwall.leaveSurvey.title');
          const subtitle = Pollfish.ui.getText(
            'offerwall.leaveSurvey.subtitle',
          );
          let textContent = `${title}\n${subtitle}`;
          // We will be showing the demographics again, if a user rejects them for offerwall
          if (
            currentPage.indexOf('tag') > -1 ||
            !Pollfish.demographics.isCompleted()
          ) {
            textContent = Pollfish.ui.getText('offerwall.leaveSurvey.subtitle');
          }
          Pollfish.ui.showConfirmationModal({
            header: Pollfish.ui.getText('offerwall.leaveSurvey.prompt'),
            content: textContent,
            onConfirm: Pollfish.ui.showFeedbackSurvey,
          });
          return;
        }
        if (currentPage.match(/(offerwall|unlock|homescreen)/)) {
          Pollfish.analytics.sendEvent(
            'general',
            'closeFromX',
            'Close from X',
            1100,
          );
          Pollfish.mobile.interface.close();
          return;
        }
        if (
          Pollfish.helper.isOfferwall() &&
          Pollfish.survey &&
          Pollfish.survey.isDemographicSurvey() &&
          Pollfish.demographics.isDisqualified() &&
          Pollfish.demographics.getDisqualificationReason() ===
            DISQUALIFICATION_USER_UNDERAGE
        ) {
          Pollfish.mobile.interface.close();
          return;
        }
        if (Pollfish.helper.isOfferwall()) {
          Pollfish.ui.showOfferwall(storedOffer ? 'offerwall-offers' : '');
          return;
        }
        Pollfish.analytics.sendEvent(
          'general',
          'closeFromX',
          'Close from X',
          1100,
        );
        Pollfish.mobile.interface.close();
      });
    },

    refresh() {
      $('#wrapper').on('tap', '.header__action-refresh-btn', (e) => {
        e.preventDefault();
        const currentPage = $('body').attr('data-page');
        if (currentPage === 'offerwall-surveys') {
          Pollfish.offerwallPage.getSurveys();
        } else if (currentPage === 'offerwall-offers') {
          Pollfish.offerwallPage.getOffers();
        } else if (currentPage === 'points') {
          Pollfish.pointsPage.getPoints();
        } else if (currentPage === 'no-survey-available--offerwall') {
          Pollfish.ui.showOfferwall();
        }
      });
    },

    onZoomImage() {
      const lightbox = $('#image-lightbox');
      const container = $('#image-lightbox .animated-container');
      $('#wrapper').on('tap', '.js-zoom-image', function onZoom(e) {
        e.stopPropagation();
        const imageSrc = $(this).data('img-src');
        container.html(
          `<div class="image-container"><img src="${imageSrc}" alt=""></div>`,
        );
        const imageContainer = container.find('.image-container');
        Pollfish.helper.pinchZoomRef = new PinchZoom(imageContainer.get(0));

        $('body').addClass('noscroll');
        $('#image-lightbox').addClass('open');
      });

      lightbox.on('tap', '.close-btn', (e) => {
        e.stopPropagation();
        // NOTE: this is a hack 100%. The library is currently crashing on resize because
        // the container is missing after remove it from the DOM. The author has not provided us
        // with a "destroy" function, but i found an "if" statement that uses
        // this variable to ignore events
        if (Pollfish.helper.pinchZoomRef) {
          Pollfish.helper.pinchZoomRef.updatePlaned = true;
        }
        container.html('');
        $('body').removeClass('noscroll');
        $('#image-lightbox').removeClass('open');
      });
    },

    addInteraction(inputEvent) {
      if (!Pollfish.event.interactions) {
        Pollfish.event.interactions = [];
      }

      const inputValue = get(inputEvent, 'target.value', '');

      const cleanEvent = {
        timestamp: Date.now(),
        inputLength: inputValue.length,
      };

      Pollfish.event.interactions.push(cleanEvent);
      // we need to capsize our interactions array
      if (Pollfish.event.interactions.length > 100) {
        Pollfish.event.interactions = takeRight(
          Pollfish.event.interactions,
          100,
        );
      }
    },

    clearInteractions() {
      Pollfish.event.interactions = [];
    },

    windowResize() {
      // calculate the correct height of the remaining view upon initialization
      Pollfish.helper.calculateWindowHeight();
      window.addEventListener(
        'resize',
        debounce(() => {
          Pollfish.helper.calculateWindowHeight();
        }, 100),
      );
    },
  };
})();

export default Pollfish.event;
